<template>
  <div>
    <span class="font-semibold">{{ location }}</span>
    <span
      v-if="fromDistance"
      class="ml-1 text-gray-500"
    >{{ fromDistance }}</span>
  </div>
</template>

<script setup lang="ts">
const { rvLocation, rvMeasurementUnit } = useRvDetails()

const { t } = useI18n()

const searchData = useSearchData()
const searchCity = computed(() => {
  const searchLocationParams = getNormalizedSearchLocationParams(searchData.value.location)
  return searchLocationParams?.city
})
const location = computed(() =>
  rvLocation.value?.City && rvLocation.value?.State
    ? `${rvLocation.value.City}, ${lookupRegionToIsoCode(rvLocation.value.State)}`
    : '',
)
const fromDistance = computed(() =>
  distance.value && searchCity.value ? `(${distance.value} ${t('from')} ${searchCity.value})` : '',
)

const distance = computed(() => {
  if (!rvLocation.value?.Latitude || !rvLocation.value?.Longitude) {
    return formatDistance(0, rvMeasurementUnit.value)
  }

  const userLocation = {
    lat: Number(searchData.value.location?.coordinates?.lat),
    lng: Number(searchData.value.location?.coordinates?.lng),
  }

  const location = { lat: rvLocation.value?.Latitude, lng: rvLocation.value?.Longitude }

  const d = distanceBetweenTwoPoints(userLocation, location)

  return formatDistance(d, rvMeasurementUnit.value)
})
</script>

<i18n lang="json">
{
  "en": {
    "from": "from"
  },
  "fr": {
    "from": "de"
  }
}
</i18n>
